/* eslint-disable @typescript-eslint/lines-between-class-members */
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { IDecision } from 'APIPackage/DecisionModule/interfaces/IDecision';

export class DecisionFormValidator {
  isSupervisor?: boolean = undefined;
  isWatchOnly?: boolean = undefined;
  isNewDecision?: boolean = undefined;
  decisionData?: IDecision = undefined;
  isDecisionStatusFillInProcess?: boolean = undefined;
  isDecisionStatusReadyForApprove?: boolean = undefined;
  isDecisionStatusCompleted?: boolean = undefined;
  isDecisionStatusDisapproved?: boolean = undefined;
  isEditableInStatusCommentsExist?: boolean = undefined;
  settings: IAdminSetting[] | undefined = undefined;
}
